const lang = {
  home: 'ホーム',
  login: 'ログイン',
  email: 'メールアドレス',
  password: 'パスワード',
  enter_your_mail: 'メールアドレスを入力する',
  enter_your_pass: 'パスワードを入力する',
  mail_or_pass_incorrect: 'メールアドレスまたは、パスワードが正しくありません。',
  forgot_password: 'パスワードがわからない方はこちら',
  register_now: 'はじめての方はこちら',
  message_conflict_login: '別のユーザーがこのアカウントでログインしています。このままログインしますか？',
  modal_conflict_login_content: '別のユーザーがこのアカウントで <br>ログインしています。<br><br> このままログインしますか？ ',
  btn_force_login: 'ログインする',
}

export default lang;



// WEBPACK FOOTER //
// ./src/lang/ja/pages/login.js